import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import { canAccessConfiguration } from "../../../utils/routeAccess";

interface PermissionProtectedRouteProps {
  children: React.ReactElement;
  /** When set, redirects here instead of /my-leads if access is denied. */
  redirectTo?: string;
}

const PermissionProtectedRoute: React.FC<PermissionProtectedRouteProps> = ({
  children,
  redirectTo = "/my-leads",
}) => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const location = useLocation();
  const roles = userProfile?.user?.roles;
  const allowed = canAccessConfiguration(roles);

  if (!allowed) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return children;
};

export default PermissionProtectedRoute;
